var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row delete-user-profile my-2"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"deletelink",on:{"click":_vm.initiateDeleteOrAnonymize}},[_vm._v(" "+_vm._s(_vm.$t('profile.moveToDeleteUserProfile'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }